var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusesBookItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#29EFA8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1266 26.8707C16.1365 25.9369 14.224 25.5537 11.8382 25.499C11.202 25.4842 10.6899 24.9725 10.6899 24.3359V14.1643C10.6899 13.5079 11.233 12.9749 11.8887 13.0009C14.5188 13.1049 16.5749 13.5793 18.8055 14.6997C19.0615 14.83 19.2245 15.1004 19.2245 15.3906V26.1662C19.2245 26.7306 18.6387 27.1104 18.1266 26.8707Z",
    fill: "#00301B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8742 26.8707C23.8643 25.9369 25.7768 25.5537 28.1626 25.499C28.7988 25.4842 29.3109 24.9725 29.3109 24.3359V14.1643C29.3109 13.5079 28.7678 12.9749 28.1122 13.0009C25.482 13.1049 23.426 13.5793 21.1992 14.6997C20.9393 14.83 20.7764 15.1004 20.7764 15.3906V26.1662C20.7764 26.7306 21.3621 27.1104 21.8742 26.8707Z",
    fill: "#00301B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusesBookItem);
export default __webpack_public_path__ + "static/media/bonusesBookItem.6b82ed4df8cbf9aac2aa203387d98fa8.svg";
export { ForwardRef as ReactComponent };